import React from 'react';
import { Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Logo, { LogoWhite } from '../../ui-library/Logo';
import styled from 'styled-components';

const StyledContainer = styled.div`
  width: 126px;
  margin-top: 14px;
  @media (max-width: 991px) {
    margin-left: 16px;
  }
`;

const Brand = ({ isDark }) => (
  <LinkContainer to='/' exact>
    <Navbar.Brand>
      <StyledContainer>{isDark ? <Logo /> : <LogoWhite />}</StyledContainer>
    </Navbar.Brand>
  </LinkContainer>
);

export default Brand;
